import styled from '@emotion/styled';
import React from 'react';
import PropTypes from 'utils/PropTypes';

const StyledSection = styled.div`
  margin-bottom: 1.5rem;
  padding-top: ${({ extraPaddingTop }) => (extraPaddingTop ? '1rem' : '0')};
`;

const Section = React.forwardRef(({ children, extraPaddingTop }, ref) => (
  <StyledSection ref={ref} extraPaddingTop={extraPaddingTop}>
    {children}
  </StyledSection>
));

Section.propTypes = {
  children: PropTypes.children,
};

Section.defaultProps = {
  children: null,
};

export default Section;
